import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { AppTokenService } from "../../app-token.service";
import { HttpHandlerService } from "../../http-handler.service";

@Injectable()

export class TATService {
    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;
    _getTATResourceEndPoint = 'tat';
    _getTATInfoResourceEndPoint = 'tat/info';
    _upload_EndPoint = 'tat/upload';

    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }

    public GetAllTypes(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getTATResourceEndPoint}/types`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetTATById(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getTATResourceEndPoint}/${params.id}?sc=${params?.scid}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetAllTAT(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getTATResourceEndPoint}?sc=${params?.scid}&pagelimit=${params?.length}&pageoffset=${params?.start}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetAllTATInfo(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getTATResourceEndPoint}/list?sc=${params?.scid}&pagelimit=${params?.length}&pageoffset=${params?.start}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetTATInfoByTATId(params: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getTATInfoResourceEndPoint}/${params.tatid}?sc=${params?.scid}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public UploadTAT(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._upload_EndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public DeleteTATById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getTATResourceEndPoint}/${id}`;
        const request_option = this._httpHandler.prepareRequest(
            'DELETE', 
            full_api_url, 
            {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public DeleteTATInfoById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getTATInfoResourceEndPoint}/${id}`;
        const request_option = this._httpHandler.prepareRequest(
            'DELETE', 
            full_api_url, 
            {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetTATInfoById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getTATResourceEndPoint}/details/${id}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public CheckTATPeriod(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getTATResourceEndPoint}/periods/check`
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }


    public UpdateTAT(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getTATResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public UpdateTATInfo(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getTATInfoResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }
}
